import { PageSize } from '@/constant';
import { GetWorkerAuditMonitoringListParams } from '@/services';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IPayloadGetWorkerAuditMonitoringListRequest,
	IPayloadGetWorkerAuditMonitoringListSuccess,
	IWorkerAuditMonitoringDetailStore,
} from './worker-audit-monitoring.type';

const InitParams: GetWorkerAuditMonitoringListParams = {
	page: 1,
	pageSize: PageSize.S,
};

const initialState = {
	fetching: false,
	list: [] as IWorkerAuditMonitoringDetailStore[],
	total: 0,
	params: InitParams,
};

const workerAuditMonitoringSlice = createSlice({
	initialState,
	name: 'workerAuditMonitoring',
	reducers: {
		/**---- GET AUDIT LIST START ---- */
		getWorkerAuditMonitoringListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerAuditMonitoringListRequest>
		) => {
			return {
				...state,
				fetching: true,
				params: action?.payload,
			};
		},
		getWorkerAuditMonitoringListSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkerAuditMonitoringListSuccess>
		) => {
			const { content, total } = action.payload;
			state.fetching = false;
			state.list = content;
			state.total = total;
		},
		getWorkerAuditMonitoringListFailure: (state) => {
			state.fetching = false;
			state.total = 0;
			state.list = [];
		},
		/**---- GET AUDIT LIST END ---- */
	},
});

export const WorkerAuditMonitoringSelectors = {
	selectFetching: (state: RootState) => state.workerAuditMonitoring.fetching,
	selectParams: (state: RootState) => state.workerAuditMonitoring.params,
	selectList: (state: RootState) => state.workerAuditMonitoring.list,
	selectTotal: (state: RootState) => state.workerAuditMonitoring.total,
};

export const WorkerAuditMonitoringActions = workerAuditMonitoringSlice.actions;
export const WorkerAuditMonitoringReducer = workerAuditMonitoringSlice.reducer;
